import { motion } from "framer-motion";
import { BadgeCheck, MessageSquare, Plane, SlidersHorizontal } from "lucide-react";
import { STEPS } from "@/data/site";
import { Reveal, SectionHead, Accent, EASE } from "@/components/Reveal";

const ICONS = { MessageSquare, SlidersHorizontal, BadgeCheck, Plane };

const HowItWorks = () => (
  <section className="py-24 sm:py-32 bg-[#0D131B] border-y border-white/10">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <SectionHead
        align="center"
        eyebrow="Effortless By Design"
        title={<>From hello to <Accent>boarding</Accent> in four steps</>}
      />
      <div className="relative mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <motion.span
          aria-hidden="true"
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1.1, ease: EASE }}
          className="hidden lg:block absolute top-8 left-[12%] right-[12%] h-px origin-left bg-gradient-to-r from-[#1E6FB8] via-[#3FB6D3] to-[#F2C230]"
        />
        {STEPS.map((s, i) => {
          const Icon = ICONS[s.icon];
          return (
            <Reveal key={s.title} delay={i * 0.12} className="relative text-center">
              <div data-testid={`how-step-${i + 1}`} className="flex flex-col items-center">
                <span className="relative z-10 w-16 h-16 rounded-full glass flex items-center justify-center text-[#F2C230]">
                  <Icon size={24} />
                  <span className="absolute -top-1.5 -right-1.5 w-6 h-6 rounded-full bg-[#F2C230] text-[#0B0F14] text-xs font-bold flex items-center justify-center">
                    {i + 1}
                  </span>
                </span>
                <h3 className="font-sora text-lg font-semibold mt-5">{s.title}</h3>
                <p className="text-sm text-[#F5F5F0]/60 leading-relaxed mt-2 max-w-[240px]">{s.text}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export default HowItWorks;
